

export const doCommonSearch = (data: any) => {
      if (data.languageStatus.length > 0 && data.intentStatus.length > 0) {
            const resultData = data.searchqaTableData?.filter((item: any) => {
                  const parsedLanguage = item.language;
                  const parsedIntent = item.intent;
                  return (
                        data.languageStatus.some((lang: any) => parsedLanguage.includes(lang)) &&
                        data.intentStatus.some((int: any) => parsedIntent.includes(int))

                  )
            });
            data.qaTableData = resultData;
            data.searchqaTableData = data.searchqaTableData;
      } else if (data.languageStatus.length > 0 || data.intentStatus.length > 0) {
            const resultData = data.searchqaTableData?.filter((item: any) => {
                  const parsedLanguage = item.language;
                  const parsedIntent = item.intent;
                  return (
                        data.languageStatus.some((lang: any) => parsedLanguage.includes(lang)) ||
                        data.intentStatus.some((int: any) => parsedIntent.includes(int))

                  )
            });
            data.qaTableData = resultData;
            data.searchqaTableData = data.searchqaTableData;

      } else {
            data.qaTableData = data.searchqaTableData;
            data.searchqaTableData = data.searchqaTableData;
      }
};